import * as React from 'react';
import classNames from 'classnames';
import Label from './Label';

const WRAPPER_CLASSES = {
  base: 'marketing-input-wrapper',
  buttonPair: 'marketing-input-button-pair',
  hasValue: 'js-is-filled',
};

const INPUT_CLASSES = {
  textField: 'marketing-input',
  floating: 'marketing-input--floating',
  error: 'marketing-input--error',
  buttonPair: 'marketing-input-button-pair__input',
};

const MESSAGE_CLASSES = {
  base: 'marketing-form__messages',
  hint: 'suggest',
  error: 'error',
  success: 'success',
  visibile: 'is-visible',
};

export interface TextFieldProps {
  id?: string;
  type?: string;
  hint?: string;
  label?: string;
  value?: string;
  error?: string;
  onBlur?: any;
  success?: string;
  onFocus?: any;
  onChange?: any;
  buttonText?: string;
  placeholder?: string;
  labelHidden?: boolean;
  renderLabel?: any;
  wrapperProps?: any;
  buttonOptions?: any;
  inputClassName?: string;
}

function NO_OP() {}

export class TextField extends React.Component<TextFieldProps> {

  constructor(props) {
    super(props);
  }

  getLabel() {
    const {
      id = '',
      label,
      labelHidden = false,
    } = this.props;

    return (
      <Label
        inField
        floating
        htmlFor={id}
        text={label}
        hidden={labelHidden}
      />
    );
  }

  getInput() {
    const {
      id = '',
      type,
      value,
      onBlur = NO_OP,
      onFocus = NO_OP,
      onChange = NO_OP,
      placeholder = '',
      inputClassName = '',
    } = this.props;

    return (
      <input
        id={id}
        type={type}
        value={value}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={onChange}
        className={classNames(INPUT_CLASSES.textField, inputClassName)}
        placeholder={placeholder}
      />
    );
  }

  getMessages() {
    const {
      hint = '',
      error = '',
      success = '',
    } = this.props;

    return (
      <span className={MESSAGE_CLASSES.base}>
        {hint ? <span className={MESSAGE_CLASSES.hint}>{hint}</span> : null}
        {error ? <span className={MESSAGE_CLASSES.error}>{error}</span> : null}
        {success ? <span className={MESSAGE_CLASSES.success}>{success}</span> : null}
      </span>
    );
  }

  getWrappedInput() {
    const {
      value = '',
      buttonText = '',
      wrapperProps = {},
    } = this.props;

    const {
      className: wrapperClassName,
      ...restWrapperProps
    } = wrapperProps;

    const composedWrapperProps = {
      className: classNames(WRAPPER_CLASSES.base, wrapperProps.className, {
        [WRAPPER_CLASSES.buttonPair]: Boolean(buttonText),
        [WRAPPER_CLASSES.hasValue]: Boolean(value),
      }),
      ...restWrapperProps,
    };

    return React.createElement(
      buttonText ? 'div' : 'label',
      composedWrapperProps,
      this.getLabel(),
      this.getInput(),
    );
  }

  render() {
    return (
      <React.Fragment>
        {this.getWrappedInput()}
        {this.getMessages()}
      </React.Fragment>
    );
  }
}

export default TextField;
